import { Typography } from "@mui/material";

const Analytics = () => {
  return (
    <>
      <Typography variant="h5" sx={{ paddingVertical: 3 }}>
        Analytics
      </Typography>
    </>
  );
};

export default Analytics;
